// @todo TypeScript does not include type definitions for the Reporting API yet.
export const createWindow = () => (typeof window === 'undefined' ? null : window);
//# sourceMappingURL=window.js.map